module.exports = __webpack_public_path__ + "img/banner-1.91ace9c2.jpg";